let sessionCache = () => {
    return sessionStorage
}

export default sessionCache